module.exports = __webpack_public_path__ + "img/ht_model.6b8fa71f.png";